const headings = $('[data-main-rich-text] > h2');
headings.before("<hr>");

headings.each((i, element) => {
    const heading = $(element);
    
    heading.addClass('is-collapsible');

    
    heading.click(() => {
        heading.toggleClass('collapsed');
        heading.nextUntil('hr').toggleClass('d-none');
    });

    if (i !== 0) {
        heading.click();
    }
});
